import { USER_LOGGED_IN_QUERY, USER_QUERY, USER_FIRST_LOGGED_IN_QUERY, USER_REQUIRES_TERMS_ACCEPTANCE_QUERY, USER_REQUIRES_SOW_QUERY, USER_HANDLE_LOGIN, TRACKING_LOGOUT, USER_SET_FIRST_LOG_IN, USER_FIRST_LOG_IN_UPDATED, USER_SET_REQUIRES_TERMS_ACCEPTANCE, USER_SET_REQUIRES_SOW, USER_LOGGED_IN_UPDATED, USER_UPDATED, CLEAR_MODALS, USER_JURISDICTION_QUERY, ACCOUNT_PEP_BLOCK_QUERY } from '@gig/magic-messages';
import { magic } from '@gig/magic-sdk';
import { isAGCO, isLOTBA, SESSION_START_TIME_KEY, INITIAL_CASH_BALANCE_KEY } from '@gig/magic-jurisdictions/dist/jurisdictions.constants';
import { storage } from '@gig/magic-sdk/dist/storage';
import { SessionCode } from '@gig/magic-sdk/dist/events';
import { notificationService } from '@gig/magic-messaging';

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
class UserSessionService {
  constructor() {
    this.user = null;
    this.isFirstLogIn = false;
    this.requiresTermsAcceptance = false;
    this.sowStatus = { isActionRequired: false };
    this.registerSchemas();
    this.registerUserSessionQueries();
    this.registerEventHandlers();
    this.subscribeToUserSessionChanges();
  }
  registerUserSessionQueries() {
    window.queryBus.subscribe(USER_LOGGED_IN_QUERY, () => {
      return !!this.user;
    });
    window.queryBus.subscribe(USER_QUERY, () => {
      return this.user;
    });
    window.queryBus.subscribe(USER_FIRST_LOGGED_IN_QUERY, () => {
      return this.isFirstLogIn;
    });
    window.queryBus.subscribe(USER_REQUIRES_TERMS_ACCEPTANCE_QUERY, () => {
      return this.requiresTermsAcceptance;
    });
    window.queryBus.subscribe(USER_REQUIRES_SOW_QUERY, () => {
      return this.sowStatus;
    });
  }
  registerEventHandlers() {
    window.eventBus.subscribe(USER_HANDLE_LOGIN, () => __async(this, null, function* () {
      const jurisdiction = yield window.queryBus.query(USER_JURISDICTION_QUERY);
      const isPepBlocked = yield window.queryBus.query(ACCOUNT_PEP_BLOCK_QUERY);
      if (isPepBlocked) {
        return;
      }
      const newBalancePromise = magic.invokeCached(10, magic.methods.wallet, "getComputedBalance")(this.user.currency);
      const newBalance = yield newBalancePromise;
      if (isAGCO(jurisdiction) || isLOTBA(jurisdiction)) {
        storage.setItem(SESSION_START_TIME_KEY, Date.now());
      }
      if (isAGCO(jurisdiction)) {
        storage.setItem(INITIAL_CASH_BALANCE_KEY, newBalance.balance);
      }
    }));
  }
  subscribeToUserSessionChanges() {
    if (magic.session.isCreated()) {
      this.handleSessionCreated();
    } else {
      this.handleSessionDestroyed();
    }
    magic.events.sessionCreated(() => {
      if (this.user) {
        return;
      }
      this.handleSessionCreated();
    });
    magic.events.sessionDestroyed(() => {
      if (!this.user) {
        return;
      }
      this.handleSessionDestroyed();
    });
    magic.events.sessionChange((code) => {
      if (code !== SessionCode.LOGGED_IN) {
        window.eventBus.publish(TRACKING_LOGOUT, code);
      }
    });
    window.commandBus.subscribe(USER_SET_FIRST_LOG_IN, (event) => {
      this.isFirstLogIn = !!event.payload;
      window.eventBus.publish(USER_FIRST_LOG_IN_UPDATED, this.isFirstLogIn);
    });
    window.commandBus.subscribe(USER_SET_REQUIRES_TERMS_ACCEPTANCE, (event) => {
      this.requiresTermsAcceptance = !!event.payload;
    });
    window.commandBus.subscribe(USER_SET_REQUIRES_SOW, (event) => {
      this.sowStatus = event.payload;
    });
  }
  handleSessionCreated() {
    this.user = magic.session.getUser();
    window.eventBus.publish(USER_LOGGED_IN_UPDATED, true);
    window.eventBus.publish(USER_UPDATED, this.user);
  }
  handleSessionDestroyed() {
    return __async(this, null, function* () {
      this.user = null;
      notificationService.closeAllNotifications();
      yield window.commandBus.publish(CLEAR_MODALS);
      window.eventBus.publish(USER_LOGGED_IN_UPDATED, false);
      window.eventBus.publish(USER_UPDATED, this.user);
    });
  }
  registerSchemas() {
    window.eventBus.register(USER_LOGGED_IN_UPDATED, {
      type: "boolean"
    });
    window.eventBus.register(USER_UPDATED, {
      anyOf: [
        {
          type: "object"
        },
        {
          type: "null"
        }
      ]
    });
  }
}

export { UserSessionService };
